import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { BreadcrumbService } from 'app/shared/services';

@Component({
  selector: 'app-topbar-breadcrumb',
  imports: [RouterLink, TranslateModule],
  templateUrl: './topbar-breadcrumb.html',
  styleUrl: './topbar-breadcrumb.scss',
})
export class TopbarBreadcrumb {

  readonly breadcrumbService = inject(BreadcrumbService);
}
